import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {ErrorHandler, NgModule} from "@angular/core";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {TabIndexService} from "@synisys/idm-dynamic-forms-ui";
import {
  CurrentLanguageProvider,
  EventBase,
  EventBaseImpl,
  SessionDataProvider,
} from "@synisys/idm-session-data-provider-api-js";
import {
  CurrentLanguageManager,
  LoginGuard,
  MainOnlineProvidersModule,
  SessionDataProviderImpl
} from "@synisys/idm-ui-shell";
import {EXCLUDED_FOR_LOADING_URLS} from "@synisys/idm-ui-shell/app/services/loading.interceptor";
import {LoginPagePreventionGuard} from "@synisys/idm-ui-shell/app/services/login-page-prevention-guard";
import {HttpUserService, UserService,} from "@synisys/idm-um-client-js";
import {HttpProcessService, ProcessService} from "@synisys/idm-workflow-service-client-js";
import {Angulartics2Module} from "angulartics2";
import {Angulartics2GoogleAnalytics} from "angulartics2/ga";
import {AppComponent} from "./app.component";
import {appRoute} from "./app.routing";
import analyticsConfig from "./config/analytics";
import {ActiveUsersTrackInterceptor} from "./interceptor/active-users-track-interceptor";
import {CachingInterceptor} from "./interceptor/caching-interceptor";
import {PrimeCustomInterceptor} from "./interceptor/prime-custom-interceptor";
import {PrimeLoadingInterceptor} from "./interceptor/prime-loading-interceptor.service";
import {PrimeProjectResponseInterceptor} from "./interceptor/prime-project-response.interceptor";
import {IndicatorTemplateInterceptor} from "./me/indicator/interceptors/indicator-template.interceptor";
import {IndicatorWorkflowInterceptor} from "./me/indicator/interceptors/indicator-workflow.interceptor";
import {PrimeErrorHandlerService} from "./prime-error-handler.service";
import {SharedSubjectModel} from "./shared/model/shared-subject.model";

@NgModule({
  imports: [
    BrowserAnimationsModule,
    HttpClientModule,
    appRoute,
    MainOnlineProvidersModule,
    Angulartics2Module.forRoot([Angulartics2GoogleAnalytics], analyticsConfig),
  ],
  declarations: [
    AppComponent,
  ],
  providers: [
    LoginPagePreventionGuard,
    LoginGuard,
    SessionDataProviderImpl,
    CurrentLanguageManager,
    {provide: CurrentLanguageProvider, useExisting: SessionDataProviderImpl},
    {provide: SessionDataProvider, useExisting: SessionDataProviderImpl},

    {provide: UserService, useClass: HttpUserService},
    {provide: ProcessService, useClass: HttpProcessService},
    {provide: EventBase, useValue: EventBaseImpl.getInstance()},

    {provide: HTTP_INTERCEPTORS, useClass: CachingInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: PrimeLoadingInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: PrimeCustomInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ActiveUsersTrackInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: IndicatorTemplateInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: IndicatorWorkflowInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: PrimeProjectResponseInterceptor, multi: true},

    {provide: EXCLUDED_FOR_LOADING_URLS, useValue: "metrics/collect", multi: true},
    {provide: EXCLUDED_FOR_LOADING_URLS, useValue: "logs/collect", multi: true},
    {provide: EXCLUDED_FOR_LOADING_URLS, useValue: "token/prolong", multi: true},
    /*{provide: ApplicationPropertiesService, useClass: DummyApplicationPropertiesService},*/
    {provide: ErrorHandler, useClass: PrimeErrorHandlerService},
    // Bug -> PRIME-15516
    TabIndexService,
    SharedSubjectModel,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
